import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import moment from 'moment';
import { fetchUserClassDictionary } from 'app/actions/dictionaries/user-class-dictionary.actions';
import { fetchActivityEventsDictionary } from 'app/actions/dictionaries/activity-events-dictionary.actions';
import template from './admin-reports-filter.html';

const TODAY = 'today';
const CURRENT_WEEK = 'currentWeek';
const LAST_WEEK = 'lastWeek';
const CURRENT_MONTH = 'currentMonth';
const LAST_MONTH = 'lastMonth';
const CUSTOM = 'custom';
const FORMAT = 'M/D/YYYY';

const mapStateToThis = ({ session, dictionary }) => {
  const { serverTime, lotteryTimezoneDiff } = session;
  const { userClass, activityEvents } = dictionary;

  return {
    serverTime,
    lotteryTimezoneDiff,
    userClass,
    activityEvents,
  };
};

const mapDispatchToThis = {
  fetchUserClassDictionary,
  fetchActivityEventsDictionary,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$scope', 'gettextCatalog', 'Notifications')
class AdminReportsFilterController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.timePeriods = this.getTimePeriods();
    this.timePeriod = this.timePeriods[1].id;
    this.$scope.$on('clearFilterUserActivityLog', () => {
      this.timePeriod = this.timePeriods[1].id;
      this.fromDate = null;
      this.toDate = null;
      this.showDateInputs = false;
    });
    this.errors = {};
    this.showDateInputs = false;
    this.$scope.$on('resetUserActivityReportsFilter', () => {
      this.timePeriod = this.timePeriods[1].id;
      this.fromDate = null;
      this.toDate = null;
      this.showDateInputs = false;
    });
    await this.fetchDictionaries();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async fetchDictionaries() {
    return Promise.all([this.fetchUserClassDictionary(), this.fetchActivityEventsDictionary()]);
  }

  getTimePeriods() {
    return [
      {
        id: TODAY,
        label: this.gettextCatalog.getString('Today'),
      },
      {
        id: CURRENT_WEEK,
        label: this.gettextCatalog.getString('This week'),
      },
      {
        id: LAST_WEEK,
        label: this.gettextCatalog.getString('Last week'),
      },
      {
        id: CURRENT_MONTH,
        label: this.gettextCatalog.getString('This month'),
      },
      {
        id: LAST_MONTH,
        label: this.gettextCatalog.getString('Last month'),
      },
      {
        id: CUSTOM,
        label: this.gettextCatalog.getString('Select dates'),
      },
    ];
  }

  handleTimePeriodChange() {
    this.showDateInputs = false;
    const lotteryTime = moment.unix(this.serverTime).utcOffset(this.lotteryTimezoneDiff);
    switch (this.timePeriod) {
      case TODAY:
        this.filters.fromDate = lotteryTime.clone().startOf('day').valueOf();
        this.filters.toDate = lotteryTime.clone().endOf('day').valueOf();
        break;
      case LAST_WEEK:
        this.filters.fromDate = lotteryTime.clone().subtract(7, 'd').startOf('week').valueOf();
        this.filters.toDate = lotteryTime.clone().subtract(7, 'd').endOf('week').valueOf();
        break;
      case CURRENT_MONTH:
        this.filters.fromDate = lotteryTime.clone().startOf('month').valueOf();
        this.filters.toDate = lotteryTime.clone().endOf('month').valueOf();
        break;
      case LAST_MONTH:
        this.filters.fromDate = lotteryTime.clone().subtract(1, 'M').startOf('month').valueOf();
        this.filters.toDate = lotteryTime.clone().subtract(1, 'M').endOf('month').valueOf();
        break;
      case CUSTOM:
        this.filters.fromDate = null;
        this.filters.toDate = null;
        this.showDateInputs = true;
        break;
      case CURRENT_WEEK:
      default:
        this.filters.fromDate = lotteryTime.clone().startOf('week').valueOf();
        this.filters.toDate = lotteryTime.clone().endOf('week').valueOf();
        break;
    }
  }

  $onChanges(changes) {
    if (changes.filters) {
      if (isEmpty(changes.filters.currentValue)) {
        this.timePeriod = this.timePeriods[1].id;
        this.fromDate = null;
        this.toDate = null;
        this.handleTimePeriodChange();
      }
    }
  }

  onFromDateChange(date) {
    this.validateDate(date, 'fromDate');
    this.filters.fromDate = moment.utc(date, FORMAT).startOf('day').valueOf();
  }

  onToDateChange(date) {
    this.validateDate(date, 'toDate');
    this.filters.toDate = moment.utc(date, FORMAT).endOf('day').valueOf();
  }

  validateDate(date, name) {
    const isValidDate = moment(date, FORMAT, true).isValid();
    if (isEmpty(date)) {
      this.errors[name] = false;
      return;
    }
    this.errors[name] = !isValidDate;
    this.displayError();
  }

  displayError() {
    if (this.errors.toDate) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Date to field - invalid date'));
    }
    if (this.errors.fromDate) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Date from field - invalid date'));
    }
  }
}

export default class AdminReportsFilterComponent {
  constructor() {
    this.template = template;
    this.controller = AdminReportsFilterController;
    this.bindings = {
      filters: '<',
      eventTypes: '<',
      idPrefix: '@',
      reportStatuses: '<',
      error: '=',
      reset: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/admin-reports-filter/admin-reports-filter-component.js